import React from "react";
import UserList from "./UserList";

const PendingApprovals = () => {

    return <>
        <UserList moduleType='isApprovalPending' />
    </>
}
export default PendingApprovals;